<template>
  <transition name="fade">
    <div class="comp-wrap" v-show="show">
      <div class="box" ref="box">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      default: false,
      type: Boolean
    },
    w: { default: 0, type: Number },
    h: { default: 0, type: Number }
  },
  mounted() {
    this.initStyle();
  },
  watch: {
    show() {
      this.$nextTick(() => {
        this.initStyle();
      });
    }
  },
  methods: {
    initStyle() {
      if (this.show && this.w) {
        this.$refs.box.style.width = this.w + "px";
      }
      if (this.show && this.h) {
        this.$refs.box.style.height = this.h + "px";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.comp-wrap {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(111, 111, 111, 0.1);
  .box {
    display: inline-block;
    background: #fff;
    border: 1px solid rgba(228, 228, 228, 1);
    border-radius: 5px;
  }
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
}
</style>
